module.exports = require('../../module.compiled').vendored[
  'react-rsc'
].ReactServerDOMWebpackServerNode
